import React from 'react';

export const ArrowRightIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 14 10" fill="none">
      <path
        d="M11.4479 4L8.39073 0.942809L9.33354 0L14 4.66646L9.33354 9.33291L8.39073 8.3901L11.4475 5.33333H0V4H11.4479Z"
        fill="#3659E3"
      />
    </svg>
  );
};
